import { useState } from "react"

export const useKeyboardIndex = (indexLength, handleEscape) => {
    const [index, setIndex] = useState(-1)

    const maxIndex = indexLength - 1

    const handleKeyDown = event => {
        let flag = false

        switch (event.key) {
            case 'Escape':
                handleEscape()
                flag = true
                break
            case 'ArrowUp':
            case 'ArrowLeft':
                setIndex(Math.max(0, index - 1))
                flag = true
                break
            case 'ArrowDown':
            case 'ArrowRight':
                setIndex(Math.min(maxIndex, index + 1))
                flag = true
                break
            case 'Home':
                setIndex(0)
                flag = true
                break
            case 'End':
                setIndex(maxIndex)
                flag = true
                break
            default:
                break
        }

        if(flag) {
            event.stopPropagation()
            event.preventDefault()
        }
    }

    const handleOnFocus = (i) => {
        if(index !== i) {
            setIndex(i)
        }
    }


    return [index, setIndex, handleKeyDown, handleOnFocus]
}